import axiosInstance from "./axiosInstance";

interface NonceResponse {
  code: string;
  signature: string;
}

export const generateNonce = async (
  platformId: string
): Promise<NonceResponse> => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_AUTH_URL}/api/generate-nonce?platformId=${platformId}`
  );
  console.log(response.data);
  return response.data;
};

export const checkEmailExists = async (email: string): Promise<boolean> => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_AUTH_URL}/api/check-email-exists?email=${email}`
  );
  return response.data.exists;
};

export const getAccounts = async (token: string, platform: string) => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_AUTH_URL}/api/get-session-from-token?token=${token}&platformId=${platform}`
  );
  return response.data;
};
